module.exports = __webpack_public_path__ + "img/ic_go_to_block_round.33279620.png";